import Vue from 'vue'

let uuid = 0

export default {
  namespaced: true,
  state: {
    items: []
  },
  mutations: {
    SHOW(state, payload) {
      state.items.push({
        id: uuid,
        ...payload
      })
      uuid += 1
    },

    REMOVE(state, id) {
      var index = state.items.indexOf(state.items.find(item => item.id === id))

      if (index !== -1) {
        state.items.splice(index, 1)
      }
    }
  },
  actions: {
    SHOW({ commit }, { text, lifetime = 4000, closeable = true, theme }) {
      const nextId = uuid
      commit('SHOW', { text, lifetime, closeable, theme })
      return Promise.resolve(nextId)
    },

    REMOVE({ commit }, { id }) {
      commit('REMOVE', id)
    },

    ERROR({ dispatch }, text) {
      return dispatch('SHOW', { text, theme: 'red' })
    },

    SUCCESS({ dispatch }, text) {
      return dispatch('SHOW', { text, theme: 'green' })
    },

    WARNING({ dispatch }, text) {
      return dispatch('SHOW', { text, theme: 'yellow' })
    }
  },
  getters: {}
}
